import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import * as _ from 'lodash';
import { BodyContentModel } from 'src/shared/model/body-content-model';
import { BodyContentComponent } from '../body-content/body-content.component';

@Component({
  selector: 'dcu-body-content-list',
  templateUrl: './body-content-list.component.html',
  styleUrls: ['./body-content-list.component.scss']
})
export class BodyContentListComponent implements OnInit {

  @Input()
  screenName;

  @Input()
  customModal;

  @Input()
  bodyContent: BodyContentModel;

  @Input()
  id: string;

  @Input()
  showFilter: boolean;

  @Input()
  isCustomStatus: boolean;

  @Input()
  statusList: Array<any>;

  @Output() selectedRow = new EventEmitter();
  @Output() priority = new EventEmitter();
  @Output() filterStatus = new EventEmitter();
  @Output() onSearchBox = new EventEmitter();
  @Output() confirm = new EventEmitter();
  @Output() deleteModel = new EventEmitter();
  @Output() selectedValueChange = new EventEmitter();
  @Output() onCustomRouting = new EventEmitter();
  @Output() onChangeFilterBox = new EventEmitter();
  @Output() closeChange: EventEmitter<boolean> = new EventEmitter();

  selectedRecords = [];

  @Input()
  refresh = false;
  @ViewChild("csBodyContent", {static: false}) csBodyContent: BodyContentComponent;

  @Input()
  isEditDateDeactivate: boolean;

  constructor() { }

  ngOnInit() {
  }

  refreshAll(refresh: boolean) {
    this.csBodyContent.tableRef.refreshTable();
    this.selectedRecords = [];
  }

  onChangeSelectedValue(value) {
    this.selectedRecords = _.clone(value);
    this.selectedValueChange.emit(value);
  }

  onSelectedRow(e) {
    this.selectedRow.emit(e);
  }

  changePriority() {
    this.priority.emit();
  }

  toggleFilter() {
    this.showFilter = !this.showFilter;
  }

  onChangeStatus(status) {
    this.filterStatus.emit(status);
  }
  onChangeDataFilter(dataFilter) {
    this.onChangeFilterBox.emit(dataFilter);
  }
  onChangeSearchBox(searchValue) {
    this.onSearchBox.emit(searchValue);
  }

  onDelete() {
    this.deleteModel.emit();
  }

  onConfirm(){
    this.confirm.emit();
  }

  customRouting(e){
    this.onCustomRouting.emit(e);
  }

  onCloseChange() {
    this.closeChange.emit(true);
  }

}
